import React from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import { Modal as M } from 'react-bootstrap';
import {animateScroll as scroll} from 'react-scroll';

export const ModalesMisPacientes = (props) => {
	const {
		ErroresFormulario,
		setErroresFormulario,
		ModalErrores,
		setModalErrores,
		ModalCorrecto,
		setModalCorrecto,
		setViewFormPaciente,
		idPaciente,
		ModalBorrarPaciente,
		setModalBorrarPaciente,
		Paciente,
		deletePaciente,
		ModalPacienteDelteOk,
		setModalPacienteDelteOk,
		ModalPacienteDelteNoOk,
		setModalPacienteDelteNoOk,
	} = props;
	return (
		<>
			<M
				centered={true}
				show={ModalErrores}
			>
				<M.Header>
					<div className='titulo-modal'>Datos del paciente erróneos</div>
				</M.Header>
				<M.Body>
					<div>
						{' '}
						{ErroresFormulario.map((error) => (
							<div className='descripcion-servicio descripcion-modal'>
								{' '}
								- {error}{' '}
							</div>
						))}{' '}
					</div>
				</M.Body>
				<M.Footer>
					<div className='centrador'>
						<button
							className='btn login-boton'
							onClick={() => setModalErrores(false)}
						>
							<b>Aceptar</b>
						</button>
					</div>
				</M.Footer>
			</M>

			<M
				centered={true}
				show={ModalPacienteDelteOk}
			>
				<M.Header>
					<div className='titulo-modal'>Usuario eliminado</div>
				</M.Header>
				<M.Body>
					<div> Enorabuena su usuario ha sido elimiando correctamente </div>
				</M.Body>
				<M.Footer>
					<div className='centrador'>
						<button
							className='btn login-boton'
							onClick={() => setModalPacienteDelteOk(false)}
						>
							<b>Aceptar</b>
						</button>
					</div>
				</M.Footer>
			</M>

			<M
				centered={true}
				show={ModalPacienteDelteNoOk}
			>
				<M.Header>
					<div className='titulo-modal'>Ups... Ha habido un problema</div>
				</M.Header>
				<M.Body>
					<div>
						No ha sido posible eliminar este usuario, por favor intentelo
						de nuevo mas tarde.
					</div>
				</M.Body>
				<M.Footer>
					<div className='centrador'>
						<button
							className='btn login-boton'
							onClick={() => setModalPacienteDelteNoOk(false)}
						>
							<b>Aceptar</b>
						</button>
					</div>
				</M.Footer>
			</M>

			<M
				centered={true}
				show={ModalCorrecto}
			>
				<M.Header>
					<div className='titulo-modal'>Enhorabuena</div>
				</M.Header>
				<M.Body>
					<div className='descripcion-servicio descripcion-modal'>
						{idPaciente == undefined
							? '¡Paciente registrado correctamente!'
							: '¡Paciente actualizado correctamente!'}
					</div>
				</M.Body>
				<M.Footer>
					<div className='centrador'>
						<button
							className='btn login-boton'
							onClick={() => {
								setModalCorrecto(false);
								setViewFormPaciente(false);
							}}
						>
							<b>Aceptar</b>
						</button>
					</div>
				</M.Footer>
			</M>

			<M
				centered={true}
				show={ModalBorrarPaciente}
			>
				<M.Header>
					<div className='titulo-modal'>Eliminar paciente</div>
				</M.Header>
				<M.Body>
					{Paciente !== undefined && (
						<div className='descripcion-servicio descripcion-modal'>
							<div>
								<p>¿Estas segura/o de que deseas eliminar este paciente?</p>
							</div>
							<div>
								<p>
									<b>Nombre: </b>
									{Paciente.nombrePaciente}
								</p>
							</div>
							<div>
								<p>
									Todos los servicios asociados con este paciente seran
									eliminados.
								</p>
							</div>
						</div>
					)}
				</M.Body>
				<M.Footer>
					<div className='buttons-modal__EliminarEncuesta'>
						<button
							className='btn outline-boton'
							onClick={() => {
								setModalBorrarPaciente(false);
							}}
						>
							<b>Cancelar</b>
						</button>
						<button
							className='btn btn-danger'
							onClick={() => {
								deletePaciente();
								scroll.scrollToTop();
								setModalBorrarPaciente(false);
							}}
						>
							<b>Eliminar</b>
						</button>
					</div>
				</M.Footer>
			</M>
		</>
	);
};
